import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompassBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7850_501869)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M104 60C104 35.6995 84.3005 16 60 16C35.6995 16 16 35.6995 16 60C16 84.3005 35.6995 104 60 104C84.3005 104 104 84.3005 104 60ZM106 60C106 85.4051 85.4051 106 60 106C34.5949 106 14 85.4051 14 60C14 34.5949 34.5949 14 60 14C85.4051 14 106 34.5949 106 60Z",
			fill: "#14151F"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M82.2001 36.5459C82.5513 36.4354 82.9406 36.5266 83.207 36.793C83.5113 37.0973 83.587 37.5623 83.3945 37.9473L68.3945 67.9473C68.2977 68.1408 68.1407 68.2978 67.9472 68.3945L37.9472 83.3945C37.5622 83.587 37.0973 83.5114 36.7929 83.207C36.4886 82.9027 36.4129 82.4377 36.6054 82.0527L51.6054 52.0527L51.6894 51.915C51.7834 51.7848 51.9076 51.678 52.0527 51.6055L82.0527 36.6055L82.2001 36.5459ZM53.2451 53.2451L39.7363 80.2637L66.7539 66.7539L80.2636 39.7363L53.2451 53.2451Z",
			fill: "url(#paint0_linear_7850_501869)"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_7850_501869",
		x1: 36.4999,
		y1: 83.5001,
		x2: 91.8682,
		y2: 69.4297,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E45D96"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7850_501869",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export default SvgCompassBig;
